import React from "react";
import "../../assets/styles/local/Loader.css";

const Loader = () => {
  return (
    <>
      {/* <div className="d-flex justify-content-center">
        <div className="spinner-border loader" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div> */}

      {/* <div className="d-flex justify-content-center">
                <div className="spinner-border" role="status">
                    <span className="visually-hidden">Loading...</span>
                </div>
            </div> */}

      <div className="mainLoaderDiv">
        <div class="loader">
          <div class="inner-circle"></div>
          <div class="outer-circle"></div>
        </div>
      </div>
    </>
  );
};

export default Loader;
